import Vue from 'vue'
import Vuex from 'vuex'
import taxonomy from './modules/taxonomy'

// Use Vuex
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    taxonomy
  },
  strict: debug
})
